<template>
  <div>Help</div>
</template>

<script>
  export default {
    data() {
    },
    methods: {
      submit() {
      }
    }

  }
</script>

<style scoped>
</style>
